import { defineMessages } from 'react-intl';

const scope = 'panel';

export default defineMessages({
  helpCategories: {
    id: `${scope}.help_categories`,
    defaultMessage: 'Help categories',
  },
  chatAssistant: {
    id: `${scope}.chat_assistant`,
    defaultMessage: 'Chat assistant',
  },
  virtualAssistant: {
    id: `${scope}.virtual_assistant`,
    defaultMessage: 'Virtual assistant',
  },
  topFaqs: {
    id: `${scope}.top_faqs`,
    defaultMessage: 'Top FAQs',
  },
  categorySelectionDescription: {
    id: `${scope}.category_selection_description`,
    defaultMessage: `Top FAQs under {selectedCategory} category are listed below`,
  },
  selectCategory: {
    id: `${scope}.select_category`,
    defaultMessage: 'Select a category',
  },
  subCategory: {
    id: `${scope}.sub_category`,
    defaultMessage: 'Select a sub-category',
  },
  coBrowseReply: {
    id: `${scope}.co_browse_reply`,
    defaultMessage: `We would like to request for CoBrowse to help you resolve your query. Please select Accept to allow us to access your screen.`,
  },
  buttonTitle: {
    id: `${scope}.button_title`,
    defaultMessage: 'Close',
  },
  loading: {
    id: `${scope}.loading`,
    defaultMessage: 'Loading',
  },
  chatbotQueryLoading: {
    id: `${scope}.chatbot_query_loading`,
    defaultMessage: 'Loading',
  },
  genesysReAuthenticating: {
    id: `${scope}.genesys_re_authenticating`,
    defaultMessage: 'Connecting',
  },
  systemFailureError: {
    id: `${scope}.system_failure_message`,
    defaultMessage:
      "Sorry, there's a problem. Please refresh the page or try again later ({errorCode})",
  },
  chatBotError: {
    id: `${scope}.chat_bot_error`,
    defaultMessage: `Sorry, there's a problem. Please refresh the page or alternatively select 'Chat with an agent' ({errorCode}).`,
  },
  chatBotInChatError: {
    id: `${scope}.chat_bot_in_chat_error`,
    defaultMessage: `Sorry, there's a problem. Please refresh the page or try again later ({errorCode}).`,
  },
  hideAriaLabel: {
    id: `${scope}.hide_aria_label`,
    defaultMessage: 'Hide chat assistant',
  },
  screenReaderText: {
    id: `${scope}.screen_reader_text`,
    defaultMessage: 'Faq list is now updated with {faqLength} items',
  },
  genesysRetrieveError: {
    id: `${scope}.genesys_retrieve_error`,
    defaultMessage: `Sorry, there's a problem retrieving your chat history. Please refresh the page and start your chat again ({errorCode}).`,
  },
  genesysError: {
    id: `${scope}.genesys_error`,
    defaultMessage: `Sorry, there's a problem. Please refresh the page and start your chat again ({errorCode}).`,
  },
  genesysEndChatMessage: {
    id: `${scope}.genesys_end_chat_message`,
    defaultMessage: `Your chat with an agent has ended.`,
  },
});
